<template>
  <div id="header_top"  v-loading="loading">
    <div id="edit_message">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  :inline="true">
            <el-form-item label="填报单位：" prop="tbDw">
              <el-input v-model="ruleForm.tbDw" size="mini"  placeholder="填报单位" ></el-input>
            </el-form-item>
            <el-form-item  prop="ptDate" label="月报时间：">
              <div class="date_block">
                <el-date-picker
                  size="mini"
                  v-model="ruleForm.ptDate"
                  type="month"
                  placeholder="月报时间"
                  value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="填报人：" prop="tbTbr">
              <el-input v-model="ruleForm.tbTbr" size="mini" placeholder="填报人"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="tbTel">
              <el-input v-model="ruleForm.tbTel" size="mini" placeholder="联系电话"></el-input>
            </el-form-item>
            <el-form-item label="责任人：" prop="tbDwfzr">
              <el-input v-model="ruleForm.tbDwfzr" size="mini" placeholder="单位责任人"></el-input>
            </el-form-item>
            <el-form-item label="填报时间：" prop="tbDate">
              <el-input v-model="ruleForm.tbDate" size="mini" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="征收标准:" prop="zsbz" id="last_input"  style="width:600px">
              <el-input v-model="ruleForm.zsbz" type="textarea" placeholder="征收标准(元/平方)：" size="mini"></el-input>
            </el-form-item>
      </el-form>
    </div>
    <div class="flex_dialog">
      <el-row :gutter="2" type="flex" class="row-bg" justify="space-around">
        <el-col :span="3"><div class="grid-content bg-purple">指标名称</div></el-col>
        <el-col :span="2"><div class="grid-content bg-purple">计量单位</div></el-col>
        <el-col :span="2"><div class="grid-content bg-purple">本月实际</div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple">{{date1}}</div></el-col>
        <el-col :span="4"><div class="grid-content bg-purple">上年同期累计数</div></el-col>
        <el-col :span="5"><div class="grid-content bg-purple">与去年同期比(-+%)</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">备注</div></el-col>
      </el-row>
      <el-row :gutter="2" type="flex" class="row-bg" justify="space-around" v-for="(item,index) in indexList" :key="index">
          <el-col :span="4" style="display: none"><div class="grid-content bg-purple">{{item.recode_id}}</div></el-col>
          <el-col :span="3"><div class="grid-content bg-purple">{{item.index_name}}</div></el-col>
          <el-col :span="2"><div class="grid-content bg-purple">{{item.index_dw}}</div></el-col>
          <el-col :span="2">
            <template>
              <div class="grid-content bg-purple" v-if="item.status == 2"><span>{{item.bysjtb}}</span></div>
              <div class="grid-content bg-purple" v-else>
                  <el-input v-model="item.bysjtb" size="mini" @change="inputChange(item,index)"></el-input >
              </div>
            </template>
          </el-col>
          <el-col :span="6"><div class="grid-content bg-purple">{{item.sun}}</div></el-col>
          <el-col :span="4">
            <template>
              <div class="grid-content bg-purple" v-if="item.status == 2"><span>{{item.sntqljs}}</span></div>
              <div class="grid-content bg-purple" v-else>
                    <el-input v-model="item.sntqljs" size="mini" @change="inputChange2(item,index)"></el-input>
              </div>
            </template>
          </el-col>
          <el-col :span="5"><div class="grid-content bg-purple">{{item.tongwi}}</div></el-col>
          <el-col :span="10"><div class="grid-content bg-purple">
            <el-input v-model="item.bz" size="mini" ></el-input></div></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import axios from '@/utils/axios.js'
  import util from '@/utils/util.js'
  export default {
    name: "filledit",
    props:{
      id:String,
    },
    data(){
      var checkPhone = (rule, value, callback) => {
        const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/   // 手机号码
        const phoneReg2 = /^0\d{2}\d{7,8}$/   // 座机号码
        if (!value) {
          return callback(new Error('请输入联系电话'))
        }
        setTimeout(() => {
          // Number.isInteger是es6验证数字是否为整数的方法,但是我实际用的时候输入的数字总是识别成字符串
          // 所以我就在前面加了一个+实现隐式转换

          if (!Number.isInteger(+value)) {
            callback(new Error('请输入数字值'))
          } else {
            if (phoneReg.test(value)) {
              callback()
            }else if(phoneReg2.test(value)){
              callback()
            } else {
              callback(new Error('电话号码格式不正确'))
            }
          }
        }, 100)
      }
      return {
        loading: false,
        date1:'',
        indexList: [],
        ruleForm:{
          tbDw:'',
          ptDate:'',
          tbTbr:'',
          tbTel:'',
          tbDwfzr:'',
          tbDate:'',
          zsbz:''
        },
        rules: {
            tbDw: [{
              required: true,
              message: '请输入填报单位',
              trigger: 'blur'
            }],
         ptDate:[{
            required: true,
            message: '请输入月报时间',
            trigger: 'blur'
          }],
          tbTbr:[{
            required: true,
            message: '请输入填报人',
            trigger: 'blur'
          }],
          tbTel:[{
            validator: checkPhone,
            trigger: 'blur'
          }],
          tbDwfzr:[{
            required: true,
            message: '请输入单位责任人',
            trigger: 'blur'
          }],
          zsbz:[{
            required: true,
            message: '请输入征收标准',
            trigger: 'blur'
          }]
        },
        all_bysjtb:0,   //（本月实际）缓交总额
        bysjtb:0,       //（本月实际）星级缓交
        all_sntqljs:0,  //（上年同期累计）缓交总额
        sntqljs:0,      //（上年同期累计）星级缓交
      }
    },
    mounted(){
      if(this.id){
        this.examine(this.id);
      }else{
        this.LoopListItem();
      }
      this.LoopListItem();
       this.gainDate1();
    },
    watch:{
      id(newValue,oldValue){
        if(newValue){
          this.examine(newValue);
        }else{
          this.LoopListItem();
        }
      }
    },
    methods:{
      initFunction(){
        this.gainDate();
        this.getTbDw();
      },
      gainDate(){//填报时间
        let _this = this;
        var myDate = new Date();
        _this.ruleForm.tbDate=util.formatDate(myDate,"yyyy-MM-dd");
        // _this.date1=`${util.formatDate(myDate,"yyyy")}年01-${util.formatDate(myDate,"MM")}月累计`
        _this.date1="本年01-"+util.formatDate(myDate,"MM")+"月累计";
      },

      LoopListItem(){ //遍历生成填报列表
        let _this = this
        _this.loading = true;
        axios.post('/base/audit/checkIndex').then(function(res){
          _this.loading = false;
          var data=res.data.data;
          data.forEach(elment=>{
            elment['bysjtb'] = 0;
            elment['sntqljs'] = 0;
            elment['indexId'] = elment.id;
          });
         _this.indexList =[...data];
        })
      },
      examine(buinessId){ //编辑按钮获取数据方法
        let _this = this
        _this.loading = true;
        axios.post('/base/audit/checkaudit',{buinessId:buinessId}).then(function(res){
          _this.loading = false;
          var data=res.data.data;
          _this.indexList = data.list;
          _this.ruleForm = data.business;
          _this.ruleForm.tbDate = util.formatDate(new Date(data.business.tbDate),"yyyy-MM-dd");
          if (buinessId==null){
            _this.gainDate1()
          }else {
          var time=data.business.ptDate;
          var year=  time.substring(0,4);
          var month=time.substring(4)
          _this.date1=year+"年1月-"+month+"月累积";
          }
        })
      },
      gainDate1(){//列表当前月份获取
        let _this = this;
        var myDate = new Date();
        _this.date1="本年01-"+util.formatDate(myDate,"MM")+"月累计";
      },
      open(value) {
        this.$alert(value, '提示', {
          confirmButtonText: '确定'
        });
      },
      submiteditForm() { //新增 编辑方
        let _this = this;
        var all_bysjtb = 0
        var bysjtb = 0
        var all_sntqljs = 0
        var sntqljs = 0
        _this.indexList.forEach(item => {
          if(item.id == 8){
            all_bysjtb = item.bysjtb
            all_sntqljs = item.sntqljs
          }
          if(item.id == 13){
            bysjtb = item.bysjtb
            sntqljs = item.sntqljs
          }
        })
        if(Number(all_bysjtb) < Number(bysjtb)){
          this.open('星级缓交额不能大于缓交总额，请重新输入')
          return
        }
        if(Number(all_sntqljs) < Number(sntqljs)){
          this.open('星级缓交额不能大于缓交总额，请重新输入')
          return
        }
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            axios.post('/base/audit/audit11',{Business:_this.ruleForm,List1:_this.indexList}).then(function(res){
              var data=res.data.data;
              debugger;
              if(data && data == 1){
                _this.open("申报成功！");
                _this.$refs['ruleForm'].resetFields(); // 点击申报之后清除表单缓存数据
                console.log(_this.$parent);
                _this.$parent.$parent.findBusiness();
              }else if(data && data == -1){
                _this.open("不能重复申报！");
              }
              else if(data && data == 0){
                _this.open("申报出错！");
              }
            });

          } else {
            _this.open("格式有误！");
            this.$emit('change-type');
          }
        });
      },
      getTbDw(){ //获取填报单位
        let _this = this;
        axios.post('/base/public/tbDw').then(function(res){
          var data=res.data.data;
          _this.ruleForm.tbDw = data[0]?data[0].name:'';
        })
      },
      inputChange(item,index){ // 计算建筑总面积
        if(item.id == 8){
          this.all_bysjtb = item.bysjtb
        }
        if(item.id == 13){
          this.bysjtb = item.bysjtb
        }
        if(Number(this.all_bysjtb) < Number(this.bysjtb) ){
          this.open('星级缓交额不能大于缓交总额，请重新输入')
          item.bysjtb = 0
          if(item.id == 8){
            this.all_bysjtb = 0
          }
          if(item.id == 13){
            this.bysjtb = 0
          }
          return
        }
        const reg = /[^0-9.]/g;
        if (reg.test(item.bysjtb)) {
          this.open('请输入正数！')
        }
        let monthArea = 0;
        let rent = 0;
        this.indexList.forEach(element => {
          if((element.indexId == '2' || element.indexId == '3') && !isNaN(element.bysjtb)){
            monthArea += Number(element.bysjtb);
            this.indexList[0].bysjtb = monthArea;//赋值给建筑总面积
          }else if((element.indexId == '5' || element.indexId == '6')&& !isNaN(element.bysjtb)){
            rent += Number(element.bysjtb);
            this.indexList[this.indexList.length-1].bysjtb = rent;//赋值给实际金额
          }else if((element.indexId == '7' || element.indexId == '8'||element.indexId == '9')&& !isNaN(element.bysjtb)){
            rent -= Number(element.bysjtb);
            this.indexList[this.indexList.length-1].bysjtb = rent;//赋值给实际金额
          }
        })

      },
      inputChange2(item,index){ // 计算建筑总面积的上年同期累计数
        if(item.id == 8){
          this.all_sntqljs = item.sntqljs
        }
        if(item.id == 13){
          this.sntqljs = item.sntqljs
        }
        if(Number(this.all_sntqljs) < Number(this.sntqljs)){
          this.open('星级缓交额不能大于缓交总额，请重新输入')
          item.sntqljs = 0
          if(item.id == 8){
            this.all_sntqljs = 0
          }
          if(item.id == 13){
            this.sntqljs = 0
          }
          return
        }
        const reg = /[^0-9.]/g;
        if (reg.test(item.sntqljs)) {
          this.open('请输入正数！')
        }
        let monthArea = 0;
        let rent = 0;
        this.indexList.forEach(element => {
          if((element.indexId == '2' || element.indexId == '3') && !isNaN(element.sntqljs)){
            monthArea += Number(element.sntqljs);
            this.indexList[0].sntqljs = monthArea;
          }else if((element.indexId == '5' || element.indexId == '6')&& !isNaN(element.sntqljs)){
            rent += Number(element.sntqljs);
            this.indexList[this.indexList.length-1].sntqljs = rent;//计算实际金额的上年同期累计数
          }else if((element.indexId == '7' || element.indexId == '8'||element.indexId == '9')&& !isNaN(element.sntqljs)){
            rent -= Number(element.sntqljs);
            this.indexList[this.indexList.length-1].sntqljs = rent;
          }
        })

      },
    }
  }
</script>

<style   scoped>
  #header_top{
    height:400px;
    overflow: auto;
  /*  width: 98%;*/
  }
  .flex_dialog{
   /* height:365px;*/
    width:99.2%;
    border:1px solid #000;
   /* overflow-y:scroll;*/
  }

  .el-row {
    margin-bottom:2px;


  }
  #header_header{
    display: flex;
    flex-wrap:nowrap;
    justify-content:space-between;
    margin-bottom: 10px;
  }
  .el-form-item{
    width:320px;
  }
   #last_input{
    width:600px;
  }
  .el-col {
    border-radius: 4px;
  }
  bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  input{
    width:100px;
  }
  textarea{
    width:700px;
    height:18px;
  }
  bg-purple-light {
    /*background: #e5e9f2;*/
  }
  .grid-content {
    border-radius: 1px;
    min-height: 30px;
    text-align:center;
    line-height: 32px;
  }
  row-bg {
    padding: 10px 0;
    /* background-color: #f9fafc;*/
  }
 /* #edit_message{
    width:100%;
    height:300px;
  }*/
</style>



// WEBPACK FOOTER //
// src/views/common/edit/filledit.vue